import { GoogleAuthProvider } from 'firebase/auth';
import { isWebviewUnsupportedByGoogleOAuth } from 'google-oauth-webview';

import Provider from 'Classes/social-providers';
import IconPtcyGoogle from 'Icons/color/IconPtcyGoogle';

export default new Provider({
  name: 'google',
  icon: IconPtcyGoogle,
  color: '#4285F4',
  // google don't allow to use the webview for login
  isDisabled: () => isWebviewUnsupportedByGoogleOAuth(navigator.userAgent),

  getProviderInstance: () => {
    const instance = new GoogleAuthProvider();
    instance.addScope('https://www.googleapis.com/auth/user.phonenumbers.read');
    instance.setCustomParameters({
      prompt: 'select_account',
    });
    return instance;
  },

  getLoginData: (data) => {
    // data._tokenResponse -> firebase user (from web)
    // data.credential -> google credential (from app)
    const accessToken = data._tokenResponse ? data._tokenResponse.oauthAccessToken : data.credential.accessToken;
    return {
      accessToken,
    };
  },
  getUserData: (data) => {
    // data.user -> firebase user (from web)
    // data.additionalUserInfo -> google user (from app)
    const firstName = data.user ? data.user.displayName.split(' ')[0] : data.additionalUserInfo.profile.given_name;
    const lastName = data.user ? data.user.displayName.split(' ')[1] : data.additionalUserInfo.profile.family_name;
    const email = data.user ? data.user.email : data.additionalUserInfo.profile.email;
    const googleId = data.user
      ? data.user.providerData.find(provider => provider.providerId === data.providerId).uid
      : data.additionalUserInfo.profile.id;
    return {
      firstName,
      lastName,
      email,
      googleId,
    };
  }
});
